import { getIcon } from '../../lib/icons';

interface ProcessStepProps {
  step: number;
  title: string;
  description: string;
  icon: string;
  isLast?: boolean;
}

export default function ProcessStep({
  step,
  title,
  description,
  icon,
  isLast = false,
}: ProcessStepProps) {
  const IconComponent = getIcon(icon);

  return (
    <div className="relative flex gap-4">
      <div className="flex flex-col items-center">
        <div className="w-12 h-12 rounded-full bg-primary-600 flex items-center justify-center text-white font-bold text-lg flex-shrink-0">
          {step}
        </div>
        {!isLast && (
          <div className="w-0.5 h-full bg-primary-200 my-2" />
        )}
      </div>
      <div className={`pb-8 ${isLast ? 'pb-0' : ''}`}>
        <div className="flex items-center gap-3 mb-2">
          <IconComponent className="w-5 h-5 text-primary-600" />
          <h3 className="font-semibold text-lg text-charcoal-900">{title}</h3>
        </div>
        <p className="text-charcoal-600 text-sm leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}
